import { render, staticRenderFns } from "./SolutionAppointment.vue?vue&type=template&id=07501bc2&"
import script from "./SolutionAppointment.vue?vue&type=script&lang=ts&"
export * from "./SolutionAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports